module.exports = __webpack_public_path__ + "img/mail-icon.9b51abd1.svg";